export default __webpack_public_path__ + "static/media/iconfinder.0a80da69.webp";